export default { init };

function init(done: any) {
  done?.();
}
